import service from "../../../assets/img/landings/emerge/service.png";
import solutions from "../../../assets/img/landings/emerge/solutions.png";
import circles from "../../../assets/img/landings/circles_light.svg";

export const data = {
  hero: {
    title: "Emerge",
    subtitle: "Feel emotions through distance and time",
    text: [
      "Emerge was born out of a desire to leverage frontier technologies to enable meaningful shared experiences. Emerge allows everyone to feel emotions and tactile sensations even in the era of social distancing. The power of ultrasound, which delivers sensations and impulses right into the palm of your hand, advanced hand tracking and huge library of sensations make your experience exceptional.",
    ],
  },

  challenge: {
    title: "Challenge",
    text: [
      "As Emerge is rapidly developing and adding new innovative features, it needs to be well thought out and constantly tested. The real challenge of this project is that it is one of a kind -- test virtual reality with tactile experience.",
    ],
  },

  solutions: {
    title: "Solutions",
    text: [
      "Agilistry team has built the entire QA process from scratch which included testing of Emerge SDK, Oculus App and the driver.  We have built pre-merge and post-merge validation checkpoints which have significantly reduced regression testing time and internal development cycles.",
    ],
    image: solutions,
    bgr: circles,
  },
  service: { image: service },
};
